const MONTH_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'] as const

export type OperacaoTrendRow = {
  month: string
  novos: number
  novosValor: number
  fechados: number
  receitaFechada: number
}

export function formatChartMonthKey(monthKey: string): string {
  const parts = monthKey.split('-')
  if (parts.length !== 2) return monthKey
  const monthIndex = Number(parts[1]) - 1
  if (monthIndex < 0 || monthIndex > 11) return monthKey
  return MONTH_LABELS[monthIndex]
}

export function buildOperacaoTrendChartData(input: {
  createdByMonth: { month: string; count: number; value: number }[]
  closedByMonth: { month: string; count: number; revenue: number }[]
}): OperacaoTrendRow[] {
  const monthKeys = new Set<string>()
  for (const row of input.createdByMonth) monthKeys.add(row.month)
  for (const row of input.closedByMonth) monthKeys.add(row.month)

  return [...monthKeys]
    .sort()
    .map((month) => {
      const created = input.createdByMonth.find((row) => row.month === month)
      const closed = input.closedByMonth.find((row) => row.month === month)
      return {
        month: formatChartMonthKey(month),
        novos: created?.count ?? 0,
        novosValor: created?.value ?? 0,
        fechados: closed?.count ?? 0,
        receitaFechada: closed?.revenue ?? 0,
      }
    })
}

export function hasOperacaoTrendData(rows: OperacaoTrendRow[]): boolean {
  return rows.some((row) => row.novos > 0 || row.fechados > 0 || row.receitaFechada > 0)
}

/** @deprecated use buildOperacaoTrendChartData */
export function buildMonthlyTrendChartData(
  monthlyData: { month: string; count: number; revenue: number }[],
) {
  return monthlyData.map((row) => ({
    month: formatChartMonthKey(row.month),
    receita: row.revenue,
    deals: row.count,
  }))
}
